import Loading from 'Shared/components/Loading'
import PageSettingsForm from './ActionForms/Components/PageSettingsForm'
import ShareSettingsForm from './ActionForms/Components/ShareSettingsForm'
import ThankYouEmailSettingsForm from './ActionForms/Components/ThankYouEmailSettingsForm'
import AdvancedSettingsForm from './ActionForms/Components/AdvancedSettingsForm'

export default function Setup({ }) {
  const [tab, setTab] = useState('pageSettings')
  
  const {settings} = useSel(s => s.builder?.flow || {})
  const actions = useSel(s => _.values(s.actions.entities) || [])
  const surveyAction = actions.find(a => a.kind === 'survey')

  const tabClasses = (thisTab) => {
    let classes = ['tab']
    if (thisTab === tab) {
      classes.push('selected')
    }
    return classes.join(' ')
  }

  if(!settings) {
    return <Loading />
  }

  return <>
    <div className="box">
      <h2 className="no-margin-top">Setup</h2>

      <div className='row margin-bottom'>
        <div className='tabs'>
          <div className={tabClasses('pageSettings')} onClick={() => setTab('pageSettings')}>Page Settings</div>
          <div className={tabClasses('shareSettings')} onClick={() => setTab('shareSettings')}>Share Settings</div>
          {surveyAction && <div className={tabClasses('emailSettings')} onClick={() => setTab('emailSettings')}>Thank You Email Settings</div>}
          <div className={tabClasses('advancedSettings')} onClick={() => setTab('advancedSettings')}>Advanced Settings</div>
        </div>
      </div>

      {tab === 'pageSettings' && <PageSettingsForm />}
      {tab === 'shareSettings' && <ShareSettingsForm />}
      {tab === 'emailSettings' && surveyAction && <ThankYouEmailSettingsForm actionId={surveyAction.id} />}
      {tab === 'advancedSettings' && <AdvancedSettingsForm />}
    </div>
  </>
}
